import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initPreviewBridge } from './utils/previewBridge';

/**
 * Storefronts always render in the merchant's chosen palette — never follow
 * the visitor's OS dark-mode preference. With `color-scheme: dark` active,
 * any element with a transparent background paints over the OS dark canvas
 * (visible in admin builder previews and screenshots), which breaks the
 * merchant's intended look. We pin the document to light explicitly.
 */
document.documentElement.classList.remove('dark');
document.documentElement.style.colorScheme = 'light';

initPreviewBridge();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
